import React from 'react';

const LoginFooter: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-6">
      <div className="container mx-auto px-4 text-center">
        <p className="text-gray-300 text-sm">
          © 2025 Matnice Eyewear. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default LoginFooter;
